// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"143":"app","489":"lib/ui-lib"}[chunkId] + "." + __webpack_require__.h().slice(0, 8) + ".css";
};